import SurveyCountApp from './SurveyCountApp';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const SurveyCountConfig = {
    auth: authRoles.cc, //  ['cc']
    routes: [
        {
            path: '/apps/surveyCount/',
            component: SurveyCountApp
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/surveyCount/SurveyCountConfig.js